/* eslint-disable import/prefer-default-export */

export const constructUserflowUrl = (path: string) => {
    /* Remove leading and trailing slashes */
    return `flow-page-${path
        ?.replace(/^\/|\/$/g, '')
        .split('/')
        .join('-')}`;
};
